import * as R from "ramda";
import { Action } from "redux";
import { AppState } from "./appState";
import ACTION_TYPE from "./ActionTypes";
import { IFilterForm } from "./overagesFilterFormActions";

export type typeMisdeliveryFilterForm = {
  type: ACTION_TYPE.MISDELIVERY_FILTER_FORM_STATE;
  misdeliveryFilterForm: IFilterForm;
};

/**
 * Redux action to update MisdeliveryFilterForm in Redux State
 * @param misdeliveryFilterForm - the params we use for the dispatch api put request Obtained from MisdeliveryFilterForm component.
 */
export const saveMisdeliveryFilterForm = (
  misdeliveryFilterForm: IFilterForm
): typeMisdeliveryFilterForm => ({
  type: ACTION_TYPE.MISDELIVERY_FILTER_FORM_STATE,
  misdeliveryFilterForm: misdeliveryFilterForm,
});

export const saveMisdeliveryFilterFormReducer = (
  state: AppState,
  action: Action
): AppState => {
  if (action.type !== ACTION_TYPE.MISDELIVERY_FILTER_FORM_STATE) {
    return state;
  }
  return R.mergeRight(state, {
    misdeliveryFilterForm: (action as typeMisdeliveryFilterForm)
      .misdeliveryFilterForm,
  });
};